var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08057 5.33325H13.7472M3.08057 5.33325V11.2C3.08057 11.9468 3.08057 12.32 3.22589 12.6052C3.35372 12.8561 3.55755 13.0602 3.80843 13.1881C4.09337 13.3333 4.46656 13.3333 5.21184 13.3333H11.616C12.3612 13.3333 12.7339 13.3333 13.0188 13.1881C13.2697 13.0602 13.4742 12.8561 13.6021 12.6052C13.7472 12.3202 13.7472 11.9476 13.7472 11.2023V5.33325M3.08057 5.33325V4.80005C3.08057 4.05331 3.08057 3.67967 3.22589 3.39445C3.35372 3.14357 3.55755 2.93974 3.80843 2.81191C4.09365 2.66659 4.46729 2.66659 5.21403 2.66659H5.74723M13.7472 5.33325V4.79786C13.7472 4.05258 13.7472 3.67939 13.6021 3.39445C13.4742 3.14357 13.2697 2.93974 13.0188 2.81191C12.7336 2.66659 12.3608 2.66659 11.614 2.66659H11.0806M11.0806 1.33325V2.66659M11.0806 2.66659H5.74723M5.74723 1.33325V2.66659",
    stroke: "#AF976E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5042430200bc3c9b74a7b4e59789bff0.svg";
export { ForwardRef as ReactComponent };